import React, { useEffect } from "react";
const PIXEL_ID = "3677529575737121";
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const n = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod(...args);
      } else {
        n.queue.push(args);
      }
    } as Fbq;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    const t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    const s = document.getElementsByTagName("script")[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      document.head.appendChild(t);
    }
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }, []);
  return <noscript data-id="element-46" data-mp="13gx5xcvg4m9q">
      <img height="1" width="1" style={{
      display: "none"
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-47" data-mp="13hgomvsx7eot" />
    </noscript>;
}